<template>
    <div class="Login container-fluid">

        <div class="row justify-content-center">
            <div class="col-12 col-md-8 col-lg-5 col-xl-3 text-center">

                <div v-if="RegistrationsEnabled || (RegistrationsEnabled == false && blnValidID)">
                    <!-- Registration form -->
                    <div v-if="!showConfirmation" class="shadow white bg-white rounded-10 p-4 mt-4">

                        <div class="pb-2 mb-2">
                            <h1>Register</h1>

                            <label class="label w-100">Institution</label>
                            <input type="text" :disabled="(UserDetails.HospitalID != '00000000-0000-0000-0000-000000000000' || FreezeForm)" v-model="UserDetails.HospitalName" class=" w-100 mt-2" />

                            <label class="label w-100">E-mail</label>
                            <input type="text" :disabled="(UserDetails.HospitalID != '00000000-0000-0000-0000-000000000000' || FreezeForm)" v-model.trim="UserDetails.Email" class=" w-100 mt-2" />

                            <password-fields v-model="UserDetails"></password-fields>

                            <div class="mt-4">
                                <navigation-button mode="custom" busy-icon="three-dots" animation="cylon" :allow-press="UserDetails.PasswordValid && UserDetails.PasswordsMatch && validateEmail && UserDetails.HospitalName.length > 3" :text="$t('login.createAccount')" @button-clicked="AttemptRegister()"></navigation-button>
                            </div>

                            <p>
                                {{RegisterResponse}}
                            </p>
                        </div>

                    </div>

                    <!-- Confirmation -->
                    <div v-else class="shadow white bg-white rounded-10 p-4 mt-4">

                        <div class="pb-2 mb-2">
                            <h1>Registration</h1>
                            <p>
                                You have successfully registered. Please check your e-mail and confirm your e-mail address by clicking on the link in the e-mail.
                            </p>
                        </div>

                    </div>
                </div>
                <div v-else-if="RegistrationsEnabled == false && blnValidID == false" class="shadow white bg-white rounded-10 p-4 mt-4">
                    <div class="pb-2 mb-2">
                        <h1>Registration</h1>
                        <p>
                            Registrations for Ray iQ are currently by invitation only.
                        </p>
                    </div>
                </div>
                <!-- Invalid ID -->
                <div v-else-if="blnValidID == false" class="shadow white bg-white rounded-10 p-4 mt-4">

                    <div class="pb-2 mb-2">
                        <h1>Access denied</h1>
                        <p>
                            You are not eligible to register with this institution.
                        </p>

                    </div>
                </div>

            </div>
        </div>

    </div>
</template>

<script>
    import axios from 'axios'
    import PasswordFields from '@/public/components/Account/PasswordFields.vue'
    import NavigationButton from "@/private/components/UI-elements/NavigationButton.vue";
    import { validateEmail } from "@/scripts/General.js"

    export default {
        name: 'Register',
        props: {

        },
        components: {
            PasswordFields,
            NavigationButton
        },
        data: function () {

            return {
                UserDetails: {
                    Email: '',
                    Password: '',
                    ConfirmPassword: '',
                    PasswordsMatch: false,
                    PasswordValid: false,
                    HospitalName: '',
					HospitalID: '00000000-0000-0000-0000-000000000000'
                },
                RegisterResponse: '',
                showConfirmation: false,
                RegistrationsEnabled: false,
                FreezeForm: false,
				blnValidID: false,
            }

        },
        beforeMount: function () {
			axios.get('/account/getRegistrationsEnabled')
                .then((response) => {
					this.RegistrationsEnabled = response.data;
				})
				.catch(function (error) {
					console.log(error);
					this.RegistrationsEnabled = false;
                });



			if (typeof this.$route.params.InstitutionID != 'undefined') {
				//Registration that joins another hospital
				//Message server to get details
				var params = { InstitutionID: this.$route.params.InstitutionID }

				//Freeze until this is done
				this.FreezeForm = true

				axios.get('/account/getInstition', { params })
					.then((response) => {
						if (response.data.name == null && response.data.ownerUserID == null) {
							//Not valid
							this.blnValidID = false
						} else {
							this.UserDetails.HospitalName = response.data.name
							this.UserDetails.HospitalID = response.data.hospitalID
                            this.blnValidID = true

							if (typeof this.$route.query.Invitee != 'undefined') {
								this.UserDetails.Email = this.$route.query.Invitee
							}
						}

						this.FreezeForm = false
					})
					.catch((error) => {
						console.log(error);
					});

			} else {
				this.blnValidID = false
			}
        },
        mounted: function () {
            
        },
        methods: {
            AttemptRegister() {

                var formData = new FormData()

				formData.append("strNewAccount", JSON.stringify(this.UserDetails));


				axios.post('/account/register2', formData, {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				})
					.then((response) => {
						if (response.status == '200') {
							this.showConfirmation = response.data;

							if (this.showConfirmation == false) {
								this.RegisterResponse = 'The registration could not be completed.'
							} else {
								this.RegisterResponse = ''
							}

						}
					})
					.catch(function (error) {
						this.RegisterResponse = error;
					}
					);


            }
        },
        computed: {
            validateEmail: function () {
				return validateEmail(this.UserDetails.Email)
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
